<template>
  <TransitionRoot as="template" :show="open">
    <!-- @close celowo nic nie robi: klik poza oknem ani Escape nie zamykają modala,
         bo zamknięcie przed skopiowaniem listy oznacza jej utratę. Zamyka tylko przycisk. -->
    <Dialog as="div" class="fixed inset-0 z-50 overflow-y-auto" @close="() => {}">
      <div class="flex min-h-screen items-center justify-center px-4 py-4 text-center sm:p-4">
        <TransitionChild
          as="template"
          enter="ease-out duration-200"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-150"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-black bg-opacity-40 backdrop-soft transition-opacity" />
        </TransitionChild>

        <TransitionChild
          as="template"
          enter="ease-out duration-200"
          enter-from="opacity-0 translate-y-3 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-150"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-3 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="relative w-full max-w-2xl overflow-hidden border border-slate-700 bg-slate-800 text-left shadow-2xl"
            style="border-radius: 28px; max-height: calc(100vh - 32px); display: flex; flex-direction: column;"
          >
            <!-- HEADER -->
            <header class="shrink-0 border-b border-slate-700 px-5 py-5 sm:px-6">
              <div class="flex items-start gap-3">
                <div class="warnIcon">
                  <ExclamationTriangleIcon class="h-5 w-5 text-amber-300" />
                </div>
                <div class="min-w-0 flex-1">
                  <div class="text-lg font-semibold tracking-tight text-white">
                    Nie udało się wysłać części maili
                  </div>
                  <div class="mt-1 text-sm text-slate-300">
                    Faktury zostały zaakceptowane i są w KSeF — do poniższych klientów nie dotarło tylko
                    powiadomienie e-mail ({{ items.length }}).
                  </div>
                </div>
              </div>
            </header>

            <!-- BODY -->
            <div class="min-h-0 flex-1 space-y-4 overflow-y-auto p-5 sm:px-6">
              <div class="adminNotice">
                Wyślij tę listę do administratora systemu.
              </div>

              <textarea
                ref="listArea"
                readonly
                class="listArea"
                :rows="Math.min(Math.max(items.length + 4, 8), 16)"
                :value="listText"
                @focus="$event.target.select()"
              ></textarea>
            </div>

            <!-- FOOTER -->
            <footer class="flex shrink-0 flex-wrap items-center justify-end gap-3 border-t border-slate-700 p-5 sm:px-6">
              <button type="button" class="primaryBtn" @click="copyList">
                <CheckIcon v-if="copyState === 'copied'" class="h-4 w-4" />
                <ClipboardDocumentIcon v-else class="h-4 w-4" />
                <span>{{ copyLabel }}</span>
              </button>
              <button type="button" class="btn" @click="close">Zamknij</button>
            </footer>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref } from "vue";
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ExclamationTriangleIcon, ClipboardDocumentIcon, CheckIcon } from "@heroicons/vue/24/outline";

export default {
  components: {
    Dialog, DialogOverlay, TransitionChild, TransitionRoot,
    ExclamationTriangleIcon, ClipboardDocumentIcon, CheckIcon,
  },

  // items: [{ invoiceName, payerName, reason }]
  props: {
    items: { type: Array, default: () => [] },
  },

  emits: ["closeModal"],

  data() {
    return {
      copyState: null, // null | 'copied' | 'selected'
      // Moment wystąpienia — administrator wie, którego przebiegu dotyczy lista.
      createdAt: new Date().toLocaleString("pl-PL"),
    };
  },

  computed: {
    copyLabel() {
      if (this.copyState === "copied") return "Skopiowano";
      if (this.copyState === "selected") return "Zaznaczono — naciśnij Cmd+C / Ctrl+C";
      return "Kopiuj listę";
    },
    listText() {
      const header = `Niewysłane powiadomienia e-mail — akceptacja faktur ${this.createdAt} (${this.items.length}):`;
      const lines = this.items.map((i) =>
        [i.invoiceName || "(brak numeru)", i.payerName, i.reason].filter(Boolean).join(" — ")
      );
      return [header, ...lines].join("\n");
    },
  },

  methods: {
    async copyList() {
      let ok = false;
      try {
        await navigator.clipboard.writeText(this.listText);
        ok = true;
      } catch (e) {
        // Brak uprawnień do schowka — kopiujemy przez zaznaczenie. Jeśli i to nie przejdzie,
        // tekst zostaje zaznaczony i mówimy wprost, żeby skopiować go skrótem.
        this.$refs.listArea.focus();
        this.$refs.listArea.select();
        try { ok = document.execCommand("copy"); } catch (e2) { ok = false; }
      }
      this.copyState = ok ? "copied" : "selected";
      setTimeout(() => { this.copyState = null; }, 4000);
    },
    close() {
      this.$emit("closeModal");
      this.open = false;
    },
  },

  setup() {
    const open = ref(true);
    return { open };
  },
};
</script>

<style scoped>
.backdrop-soft { backdrop-filter: blur(3px); }

.warnIcon {
  height: 40px; width: 40px; border-radius: 16px; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  border: 1px solid rgba(245,158,11,0.45); background: rgba(245,158,11,0.12);
}

.adminNotice {
  border-radius: 18px;
  border: 1px solid rgba(245,158,11,0.45);
  background: rgba(245,158,11,0.10);
  padding: 12px 14px;
  font-size: 14px; font-weight: 700; color: #fde68a;
}

.listArea {
  width: 100%;
  resize: vertical;
  border-radius: 14px;
  border: 1px solid rgba(100,116,139,0.75);
  background: rgba(15,23,42,0.7);
  color: #f8fafc;
  padding: 11px 14px;
  font-size: 13px; line-height: 1.6;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.listArea:focus {
  outline: none;
  border-color: rgba(99,102,241,0.85);
  box-shadow: 0 0 0 3px rgba(99,102,241,0.15);
}

.btn, .primaryBtn { white-space: nowrap; }

.btn {
  height: 40px; padding: 0 16px; border-radius: 16px;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  border: 1px solid rgba(100,116,139,0.65); background: rgba(51,65,85,0.78);
  color: #e2e8f0; font-size: 12px; font-weight: 600; transition: 180ms ease;
}
.btn:hover { background: rgba(71,85,105,0.95); }

.primaryBtn {
  height: 40px; padding: 0 16px; border-radius: 16px;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  border: 1px solid rgba(59,130,246,0.45); background: rgba(37,99,235,0.18);
  color: #dbeafe; font-size: 12px; font-weight: 700; transition: 180ms ease;
}
.primaryBtn:hover { background: rgba(37,99,235,0.28); }
</style>
